export const addUrlToMedia = (docMedia) => {
  if (!docMedia) {
    return "";
  }
  if (!docMedia.urls) {
    return docMedia.url || "";
  }
  if (docMedia.urls.optimized) {
    return docMedia.urls.optimized;
  }
  if (docMedia.urls.original) return docMedia.urls.original;
  return docMedia.url || "";
};
